/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 대기 중
 * `rendering` - 렌더링 중
 * `uploading` - S3 업로드 중
 * `completed` - 완료
 * `failed` - 실패
 * `cancelled` - 취소됨
 */
export type VideoRenderJobStatusEnum =
  (typeof VideoRenderJobStatusEnum)[keyof typeof VideoRenderJobStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoRenderJobStatusEnum = {
  pending: "pending",
  rendering: "rendering",
  uploading: "uploading",
  completed: "completed",
  failed: "failed",
  cancelled: "cancelled",
} as const;
